"use client";

import { ArrowDown } from "lucide-react";
import React from "react";
import { Button } from "@/components/ui/button";
import { Hero } from "@/components/ui/Hero";
import { MotionLink } from "@/components/ui/Motion";
import { URLS } from "@/lib/consts";
import { SECTION_ID } from "../FloorPlansList/floor-plans-list";
import { FLOOR_PLANS_HERO_DESC, FLOOR_PLANS_HERO_TITLE } from "./consts";

const HREF = `#SECTION-${SECTION_ID}`;

function FloorPlansHero() {
  return (
    <Hero title={FLOOR_PLANS_HERO_TITLE} desc={FLOOR_PLANS_HERO_DESC}>
      <Button size="lg" variant="default" asChild>
        <MotionLink href={URLS.REQUEST_CONSULTATION}>
          Request A Consultation
        </MotionLink>
      </Button>

      <Button size="lg" variant="secondary" asChild>
        <MotionLink href={HREF}>
          <ArrowDown />
          View Our Floor Plans
        </MotionLink>
      </Button>
    </Hero>
  );
}

export default FloorPlansHero;
